import type { CanvasElement, ChartType } from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase } from '../registry/factoryShared';

export function createChartElement(
  config: BaseElementConfig & {
    chartType: ChartType;
    spec: unknown;
  },
): CanvasElement<'chart'> {
  return {
    ...createBase('chart', config),
    data: {
      chartType: config.chartType,
      spec: config.spec,
    },
  };
}
